import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=273b1508&scoped=true&"
import script from "./DocumentUpload.vue?vue&type=script&lang=ts&"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=273b1508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b1508",
  null
  
)

export default component.exports